export enum API {
    Accessories = "ACCESSORIES_API",
    AccessoriesPayments = "ACCESSORIES_PAYMENTS",
    Account = "ACCOUNT_API",
    Deal = "DEAL_API",
    Payments = "PAYMENTS",
    Vehicles = "VEHICLES_API",
    ConditionalRebates = "CONDITIONAL_REBATES_API",
    TradeIn = "TRADE_IN",
    TestDrive = "TEST_DRIVE",
    Messages = "MESSAGES",
    CreditApp = "CREDIT_APP",
    CreditIQ = "CREDIT_IQ",
}

export enum DealRoutes {
    GetDeal = "GET_DEAL",
    GetDealPerson = "GET_DEAL_PERSON",
    PatchDealPerson = "PATCH_DEAL_PERSON",
}

export enum DealResponses {
    CreateError = "CREATE_DEAL_ERROR",
    CreateSuccess = "CREATE_DEAL_SUCCESS",
    GetDealError = "GET_DEAL_ERROR",
    GetDealPersonError = "GET_DEAL_PERSON_ERROR",
    IncrementRevision = "INCREMENT_DEAL_REVISION",
    PatchDealPersonError = "PATCH_DEAL_PERSON_ERROR",
    PatchDealPersonSuccess = "PATCH_DEAL_PERSON_SUCCESS",
    UpdateVehiclePayments = "UPDATE_VEHICLE_PAYMENTS",
    UpdateVehiclePaymentsError = "UPDATE_VEHICLE_PAYMENTS_ERROR",
    UpdateAccessRequest = "UPDATE_ACCESS_REQUEST",
}

export enum AccountRoutes {
    GetAccount = "GET_ACCOUNT",
}

export enum AccountResponses {
    GetError = "GET_ACCOUNT_ERROR",
    GetSuccess = "GET_ACCOUNT_SUCCESS",
}
